import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { StationService } from 'src/app/services/station.service';
import { ReservationService } from 'src/app/services/reservation.service';
import { ArService } from 'src/app/services/ar.service';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { NotifierService } from "angular-notifier";

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit {

  allCustomerServices;
  stationsList;
  activePage
  searchText;
  agencyData;
  filters_form: FormGroup;
  isShow: boolean = true;
  statusList = [
    {
      label: 'Active', value: true,
    },
    {
      label: 'Inactive', value: false,
    }
  ]

  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private stationService: StationService,
    private formBuilder: FormBuilder,
    notifier: NotifierService,
    private arService: ArService) {
  }

  showFilter() {
    this.isShow = !this.isShow;
  }
  getData() {
    this.searchText = ''
    this.getCustomerServices();
    this.getAllStations()
  }

  ngOnInit() {
      this.filters_form = this.formBuilder.group({
        status: new FormControl([true]),
      });
     this.getData();
  }

  addCustomer() {
    this.router.navigateByUrl("home/add-customer-service");
  }

  editCustomerService(customerService) {
  //  console.log(customerService.CUSTOMER_ID)
    this.router.navigate(["home/edit-customer-service", customerService.CUSTOMER_ID])
    //this.router.navigate(["home/edit-customer-service",customerService.CUSTOMERBYSTATIONID,customerService.CONTRACTSERVICESID])
  }
  
  getAgencyName(aid){
//   console.log('agency id: ' + aid)
  //  this.arService.getAllAgenciesDataa(aid).subscribe(cData => {
  //   this.agencyData = cData['result']
  //   console.log(this.agencyData)
  //   return this.agencyData['COMPANY_NAME']
  //  })
  }

  calculateActiveCustomers(customers) {
    let activeCount = 0
    customers.forEach(cus => {
      if (cus.ACTIVE) {
        activeCount++
      }
    });
    return activeCount
  }

  calculateInActiveCustomers(customers) {
    let inactiveCount = 0
    customers.forEach(cus => {
      if (!cus.ACTIVE) {
        inactiveCount++
      }
    });
    return inactiveCount
  }

  getCustomerServices(status:boolean[] = []) {
    this.spinner.show();
   this.arService.getAllCustomers(status).subscribe(res => {
     this.allCustomerServices = res['result']
     //console.log(this.allCustomerServices)
     this.spinner.hide();
   });
  }

  onSearch(value) {
    if (
        value.status.length == 0

    ) {
      return;
    }

    this.getCustomerServices(value.status);
  }

  onClear() {
    this.searchText = "";
    this.isShow = true;
    this.filters_form.reset();
    this.filters_form.controls.status.setValue([true]);

    this.getCustomerServices();
  }

  getCustomerServicesByStationIds() {
    // this.employeeService.getEmployeesByStationId(this.stationsList).subscribe(data => {
    //   this.spinner.hide();
    //   if (data['result'] != null) {
    //     this.allEmployees = data['result'] as [];
    //     this.allEmployees = this.allEmployees.reverse();
    //   }
    // });
  }

  

  getAllStations() {
    this.stationService.getStations().subscribe(stations => {
      this.stationsList = stations['result'];
      // console.log(this.stationsList)
    })
  }

}
